import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("setShiftEditorOpen", function setShiftEditorPanelOpen(panelOpen: boolean) {
    shiftEditorViewState().isOpen = panelOpen;
});